<template>
  <div>
    <Form
      ref="addModel"
      :model="addModel"
      :rules="ruleValidate"
      :label-width="100"
      inline
    >
      <FormItem label="用户名称" prop="userName">
        <Input class="w-250" v-model="addModel.userName"></Input>
      </FormItem>
      <FormItem label="医院名称" prop="hospitalName">
        <Input class="w-250" v-model="addModel.hospitalName"></Input>
      </FormItem>
      <FormItem label="秘钥" prop="secret">
        <Input class="w-250" v-model="addModel.secret"></Input>
      </FormItem>
      <FormItem label="服务名称" prop="serverName">
        <Input class="w-250" v-model="addModel.serverName"></Input>
      </FormItem>
      <FormItem label="hospitalId" prop="hospitalId">
        <Input class="w-250" v-model="addModel.hospitalId"></Input>
      </FormItem>
      <FormItem label="accessId" prop="accessId">
        <Input class="w-250" v-model="addModel.accessId"></Input>
      </FormItem>
      <FormItem label="achiveApi" prop="achiveApi">
        <Input class="w-250" v-model="addModel.achiveApi"></Input>
      </FormItem>
      <FormItem label="dImageUrl" prop="dImageUrl">
        <Input class="w-250" v-model="addModel.dImageUrl"></Input>
      </FormItem>
      <FormItem label="deleteFlag" prop="deleteFlag">
        <Input class="w-250" v-model="addModel.deleteFlag"></Input>
      </FormItem>
      <FormItem label="eUnityAddress" prop="eUnityAddress">
        <Input class="w-250" v-model="addModel.eUnityAddress"></Input>
      </FormItem>
      <FormItem label="eUnityUser" prop="eUnityUser">
        <Input class="w-250" v-model="addModel.eUnityUser"></Input>
      </FormItem>
      <FormItem label="maxDays" prop="maxDays">
        <Input class="w-250" v-model="addModel.maxDays"></Input>
      </FormItem>
      <FormItem label="privateKey" prop="privateKey">
        <Input class="w-250" v-model="addModel.privateKey"></Input>
      </FormItem>
      <FormItem label="productCode" prop="productCode">
        <Input class="w-250" v-model="addModel.productCode"></Input>
      </FormItem>
      <FormItem label="providerId" prop="providerId">
        <Input class="w-250" v-model="addModel.providerId"></Input>
      </FormItem>
      <FormItem label="publicKey" prop="publicKey">
        <Input class="w-250" v-model="addModel.publicKey"></Input>
      </FormItem>
      <FormItem label="rasType" prop="rasType">
        <Input class="w-250" v-model="addModel.rasType"></Input>
      </FormItem>
    </Form>
    <div class="text-center modal-foter">
      <Button class="mr-5" @click="returnBack">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">确 定</Button
      >
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      organParentName: "",
      addModel: {
        
      },
      ruleValidate: {
        
      },
    };
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("secret/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },
    Generate() {
      var Current = this;
      this.$api.post("secret/GenerateKey").then((rsp) => {
        if (rsp.statusCode == "200") {
          Current.addModel.SecretID = rsp.data.privateKey;
          Current.addModel.SecretKey = rsp.data.publicKey;
        } else {
          this.$Message.success("添加成功");
          return;
        }
      });
    },
    resetData() {
      this.addModel.SecretType = null;
      this.addModel.SecretID = "";
      this.addModel.Name = "";
      this.addModel.SecretKey = "";
      this.$refs["addModel"].resetFields();
    },
  },
};
</script>
<style scoped>
</style>